import {
    LESS_1140_MEDIA_QUERY,
    LESS_984_MEDIA_QUERY,
    LESS_512_MEDIA_QUERY,
} from '../../../../../consts/adaptive';

export const styles = {
    container: {
        position: 'relative',
        height: 79,
        marginTop: 10,
        padding: [17, 20],
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr',
        gap: '10px 40px',
        boxSizing: 'border-box',
        background: '#E7E7E7',
        borderRadius: 8,

        ['&::after']: {
            content: '""',
            position: 'absolute',
            top: -20,
            left: 23,
            height: 50,
            width: 2,
            display: 'block',
            backgroundColor: '#E7E7E7',
        },
    },
    [LESS_1140_MEDIA_QUERY]: {
        container: {
            height: 'auto',
            padding: [17, 12],
            gap: '10px 5px',
        },
    },
    [LESS_984_MEDIA_QUERY]: {
        container: {
            padding: '17px 20px',
            gap: '10px 40px',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '1fr 1fr  1fr',
        },
    },
    [LESS_512_MEDIA_QUERY]: {
        container: {
            padding: '13px',
            gap: '14px',
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
